
import Vue from 'vue'
import Button from '@/components/atoms/Button.vue'

export default Vue.extend({
  name: 'Toast',
  created: function () {
    window.addEventListener('resize', this.onResize)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.onResize)
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    offsetY: {
      type: Number,
      required: false,
      default: 32,
    },
    offsetYMobile: {
      type: Number,
      required: false,
      default: 32,
    },
    target: {
      type: [Boolean, String],
      required: false,
      default: true,
    },
    mobileTarget: {
      type: [Boolean, String],
      required: false,
      default: true,
    },
    mobileBreakpoint: {
      type: Number,
      required: false,
      default: 640,
    },
    maxWidth: {
      type: Number,
      required: false,
    },
    // Used by Quasar's tooltip component for screen sizes >= 640
    anchorPosition: {
      type: String,
      required: false,
      default: 'bottom right',
    },
    // Used by Quasar's tooltip component for screen sizes < 640
    anchorPositionMobile: {
      type: String,
      required: false,
      default: 'bottom middle',
    },
    // Used by Quasar's tooltip component for screen sizes >= 640
    selfPosition: {
      type: String,
      required: false,
      default: 'top right',
    },
    // Used by Quasar's tooltip component for screen sizes < 640
    selfPositionMobile: {
      type: String,
      required: false,
      default: 'top middle',
    },
    priority: {
      required: true,
    },
    buttonPrimaryWarningText: {
      // this will only be applied to warning toasts
      type: String,
      required: false,
      default: 'Discard Changes',
    },
    buttonSecondaryWarningText: {
      // this will only be applied to warning toasts
      type: String,
      required: false,
      default: 'Continue Editing',
    },
    buttonPrimaryErrorText: {
      // this will only be applied to error toasts
      type: String,
      required: false,
      default: 'Yes, Remove it',
    },
    buttonSecondaryErrorText: {
      // this will only be applied to error toasts
      type: String,
      required: false,
      default: 'No, Keep it',
    },
    singleButton: {
      // rare case where there is only one action button
      type: Boolean,
      required: false,
      default: false,
    },
    contentClass: {
      type: String,
      required: false,
    },
  },
  methods: {
    onResize: function () {
      if (window.innerWidth < this.mobileBreakpoint) {
        this.isMobile = true
        this.currentTarget = this.mobileTarget
        this.currentOffsetY = this.offsetYMobile
        this.currentAnchorPosition = this.anchorPositionMobile
        this.currentSelfPlacementPosition = this.selfPositionMobile
        let windowWidthWithSpacing = window.innerWidth - 34
        if (this.maxWidth < windowWidthWithSpacing) {
          this.currentMaxWidth = this.maxWidth + 'px'
        } else if (windowWidthWithSpacing < 500) {
          this.currentMaxWidth = 'calc(100vw - 34px)'
        } else {
          this.currentMaxWidth = '500px'
        }
      } else {
        this.isMobile = false
        this.currentTarget = this.target
        this.currentOffsetY = this.offsetY
        this.currentAnchorPosition = this.anchorPosition
        this.currentSelfPlacementPosition = this.selfPosition
        this.currentMaxWidth = this.maxWidth + 'px'
      }
    },
  },
  data: () => ({
    currentOffsetY: 32,
    currentTarget: true as string | boolean,
    currentAnchorPosition: '',
    currentSelfPlacementPosition: '',
    isMobile: false,
    currentMaxWidth: '',
  }),
  beforeMount: function () {
    this.onResize()
  },
  components: {
    Button,
  },
})
